module.exports = __webpack_public_path__ + "static/media/11NEPAD3.87393842.jpg";